module.exports = __webpack_public_path__ + "img/f1fbb532777497264f1a2c8d1c5d23c1.png";